// extracted by mini-css-extract-plugin
export var clickable = "Logo-module--clickable--50cc4";
export var container = "Logo-module--container--06714";
export var footer = "Logo-module--footer--d98d3";
export var header = "Logo-module--header--df395";
export var navbar = "Logo-module--navbar--78d38";